var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.4C4.63509e-08 6.04654 0.286538 5.76 0.64 5.76L11.8949 5.76L7.22745 1.09255C6.97752 0.842612 6.97752 0.437388 7.22745 0.187451C7.47739 -0.0624838 7.88261 -0.0624838 8.13255 0.187451L13.8925 5.94745C14.1425 6.19739 14.1425 6.60261 13.8925 6.85255L8.13255 12.6125C7.88261 12.8625 7.47739 12.8625 7.22745 12.6125C6.97751 12.3626 6.97751 11.9574 7.22745 11.7074L11.8949 7.04L0.64 7.04C0.286538 7.04 -4.6351e-08 6.75346 0 6.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.a67c7690307da5b4147f485b17aab1b8.svg";
export { ForwardRef as ReactComponent };